// Central on/off switches for features that exist in the codebase but aren't
// ready to expose to users yet. Flip a flag to true to bring the feature back —
// nothing is deleted, just hidden.

// Hospital profile claiming ("Work at this hospital? Request to claim this
// profile"): an early idea for getting hospitals involved and, eventually,
// generating revenue. The claim form, admin review queue, and verified-profile
// display all exist, but nothing is built on top yet, so the entry points are
// hidden until there's a plan. Re-enable by setting this to true.
export const HOSPITAL_CLAIM_ENABLED = false;

// Contextual affiliate offers (pet insurance, online pharmacy) shown on cost
// pages. Kept OFF until real affiliate programs are signed up and the URLs in
// affiliateOffers.js are filled in. Flip to true to go live. Always renders
// clearly-labeled "Sponsored" and never affects the price data shown.
export const AFFILIATE_ENABLED = false;

// Also forward upload-funnel events to Plausible as custom events. Our own
// server-side funnel (models/FunnelEvent + admin dashboard) is the primary,
// owned analytics; this is OFF because Plausible's funnel view is a paid tier.
// Flip to true to also send the events to Plausible (e.g. after upgrading the
// Plausible plan) — no other rewiring needed. Only sends coarse, non-personal
// metadata, same as the server-side funnel.
export const PLAUSIBLE_FUNNEL_EVENTS = false;
